import React, { Component } from 'react'
import Link from '../utils/link'
import AppraisalForm from './appraisal-form'
import ContactForm from './contact-form'

class Contact extends Component {

  render() {

    let { title, content, form, stickyButton } = this.props

    return (
      <section className={`contact ${form === 'contact' && 'contact--contact'}`} id='contact-form'>

        <div className='contact__inner'>

          <div className='contact__content'>

            <div className='contact__menu'>

                <ul>
                  { form === 'contact' &&
                    <li>Enquiry</li>
                  }
                  { form === 'projects' &&
                    <li>Enquiry</li>
                  }
                  { form === 'appraisal' &&
                    <li>Contact Us</li>
                  }
                  { form === 'lease' &&
                    <li>Contact Us</li>
                  }
                  { form === 'sales' &&
                    <li>Contact Us</li>
                  }
                </ul>

            </div>

            <div className='contact__form'>

              <h2> { title }</h2>

              <div dangerouslySetInnerHTML={{ __html: content }} />
              
              { form === 'contact' &&
                <ContactForm {...this.props} />
              }
              { form === 'projects' &&
                <ContactForm type='New Projects' {...this.props} />
              }
              { form === 'appraisal' &&
                <>
                  <AppraisalForm {...this.props} />
                </>
              }
              { form === 'lease' &&
                <>
                  <AppraisalForm type='Lease' email='todd@kollosche.com.au' {...this.props} />
                </>
              }
              { form === 'sales' &&
                <>
                  <AppraisalForm type='Sales' email='info@kollosche.com.au' {...this.props} />
                </>
              }

            </div>

          </div>

        </div>

        { stickyButton && 
          <button onClick={() => window && window.scrollTo({top: document.querySelector('#contact-form').offsetTop - 100,left: 100, behavior: 'smooth'})} className='contact__scroller' type='button'>Contact Us</button>
        }
        
      </section>
    )
  }
}

export default Contact
